module.exports = __webpack_public_path__ + "static/img/92-3.3a8b7f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/92-3.jpg
// module id = xO2z
// module chunks = 0